module.exports = __webpack_public_path__ + "img/pop_wallet_logo_coinhub@2x.45c4d252.svg";